<template>
    <div class="game-btn" @click="onButtonClick">
        <div class="content">
            <img src="@/assets/dino/dino_btn.png">
            <span class="game-lbl">{{ translate('play_dino') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "DinoButton",
    components: {},
    data() {
        return {
            gameLoaded: false,
            show: this.settings !== null,
        }
    },
    watch: {
        settings(newValue) {
            this.show = newValue !== null
        }
    },
    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
    },
    mounted() {

    },
    methods: {
        onButtonClick() {
            if (this.settings && this.settings.onClickHandler) this.settings.onClickHandler()
        },
    },
}
</script>

<style scoped>
.game-btn {
    border: 2px solid #3F405C;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100px;
    height: 100px;
    background-color: #f8f8f8;
    border-top-left-radius: 100px;
    border-right: 0;
    border-bottom: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.game-btn:active {
    background-color: #afafaf;
}

.fadeInBottom {
    animation-name: fadeInBottom;
    animation-duration: 0.4s;
    animation-fill-mode: both;
}

@keyframes fadeInBottom {
    from {
        opacity: 0;
        transform: translate(100%, 100%);
    }
    to {
        opacity: 1
    }
}

.content {
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 0;
    right: 0;
    align-items: center;
    width: 85%;
    height: 80%;
}

.game-btn img {
    width: 50px;
    margin-left: 6px;
}

.game-lbl {
    color: #36BC00;
    font-size: 16px;
    margin-top: 4px;
    margin-right: 4px;
    white-space: nowrap;
}
</style>